import React from 'react';

import i18n from '@client/utils/i18n';
import { LinkTypeChip } from '@ledium/ui-common';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

type Scenario = 'copy' | 'link-sync' | 'link-independent';

interface ZoneWizardStep2Props {
    scenario: Scenario;
    onChange: (scenario: Scenario) => void;
}

interface ScenarioOption {
    value: Scenario;
    label: string;
    sublabel: string;
    linkType?: string;
}

function ZoneWizardStep2({ scenario, onChange }: ZoneWizardStep2Props) {
    const options: ScenarioOption[] = [
        {
            value: 'copy',
            label: i18n('copy') as string,
            sublabel: i18n('copy_zone_copy_sublabel') as string
        },
        {
            value: 'link-sync',
            label: i18n('copy_zone_link_sync_label') as string,
            sublabel: i18n('copy_zone_link_sync_sublabel') as string,
            linkType: 'mirror'
        },
        {
            value: 'link-independent',
            label: i18n('copy_zone_link_independent_label') as string,
            sublabel: i18n('copy_zone_link_independent_sublabel') as string,
            linkType: 'independent'
        }
    ];

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {i18n('copy_zone_step2_heading')}
            </Typography>
            <RadioGroup value={scenario} onChange={(e) => onChange(e.target.value as Scenario)}>
                {options.map((option) => (
                    <Box key={option.value} sx={{ mb: 1 }}>
                        <FormControlLabel
                            value={option.value}
                            control={<Radio />}
                            label={
                                <Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="subtitle2">{option.label}</Typography>
                                        {option.linkType && <LinkTypeChip type={option.linkType} />}
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">
                                        {option.sublabel}
                                    </Typography>
                                </Box>
                            }
                        />
                    </Box>
                ))}
            </RadioGroup>
        </Box>
    );
}

export default ZoneWizardStep2;
